
import DistributionEditComponent from "../../../components/distributions/Edit.vue";

export default {
  components: {
    DistributionEditComponent,
  },
};
